import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SpinnerService } from '../../../../core/service/spinner.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SpinnerType } from '../../../../util/interceptors/spinner-types';

/**
 * Represents spinner that shows on every page load.
 *
 * [Spinners](https://loading.io/css) for the Spinner God!
 * Animations for the Animation Throne!
 */
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit, OnDestroy, AfterViewInit {
  private _destroyStream: Subject<void> = new Subject<void>();
  isActive: boolean;
  spinnerText: string = '';
  currentSpinnerType: SpinnerType = SpinnerType.DEFAULT;
  SpinnerType = SpinnerType;
  @ViewChild('componentSpinner') componentSpinner: ElementRef<HTMLElement>;

  constructor(private spinnerService: SpinnerService) {}

  ngAfterViewInit(): void {
    this.componentSpinner.nativeElement.setAttribute('style', 'display: none');
    this.spinnerService.setLocalSpinnerTemplate(this.componentSpinner);
  }

  ngOnInit(): void {
    this.spinnerService.isActive.pipe(takeUntil(this._destroyStream)).subscribe((isActive) => {
      if (isActive === undefined) {
        return;
      }
      this.isActive = isActive;
    });
    this.spinnerService.spinnerText
      .pipe(takeUntil(this._destroyStream))
      .subscribe((text: string): void => {
        this.spinnerText = text;
      });
    this.spinnerService.currentSpinnerType
      .pipe(takeUntil(this._destroyStream))
      .subscribe((spinnerType: SpinnerType): void => {
        this.currentSpinnerType = spinnerType;
      });
  }

  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }
}
